// extracted by mini-css-extract-plugin
module.exports = {"reply":"Index_reply__2Dfi1","info":"Index_info__1sF4S","thumbs":"Index_thumbs__3HV4V"};